'use strict'

function validate_password(password_field){
	// Validate password, must be used on user creation form

	const passwordValidationWrapper = password_field.closest('form')?.querySelector('.password-validation-wrapper');
	const gamification = passwordValidationWrapper.getAttribute('data-gamification');

	if (!passwordValidationWrapper) return;

	const letterRegex = /[a-zA-Z]/;
	const numberRegex = /\d/;
	const symbolRegex = /[!@#$%^&*()_+{}\[\]:;<>,.?/~\\\-=`]/;

	const upperLetterRegex = /[A-Z]/;
	const lowerLetterRegex = /[a-z]/;

	if (letterRegex.test(password_field.value)) {
		passwordValidationWrapper.querySelector('.letter')?.classList.add('valid');
	} else {
		passwordValidationWrapper.querySelector('.letter')?.classList.remove('valid');
	}

	if(gamification === 'true'){
		if(upperLetterRegex.test(password_field.value)){
			passwordValidationWrapper.querySelector('.uppercase-letter')?.classList.add('valid');
		}else{
			passwordValidationWrapper.querySelector('.uppercase-letter')?.classList.remove('valid');
		}

		if(lowerLetterRegex.test(password_field.value)){
			passwordValidationWrapper.querySelector('.lowercase-letter')?.classList.add('valid');
		}else{
			passwordValidationWrapper.querySelector('.lowercase-letter')?.classList.remove('valid');
		}
	}


	if (numberRegex.test(password_field.value)) {
		passwordValidationWrapper.querySelector('.number')?.classList.add('valid');
	} else {
		passwordValidationWrapper.querySelector('.number')?.classList.remove('valid');
	}

	if (symbolRegex.test(password_field.value)) {
		passwordValidationWrapper.querySelector('.symbol')?.classList.add('valid');
	} else {
		passwordValidationWrapper.querySelector('.symbol')?.classList.remove('valid');
	}

	if(gamification !== 'true'){
		if (password_field.value.length >= 7) {
			passwordValidationWrapper.querySelector('.length')?.classList.add('valid');
		} else {
			passwordValidationWrapper.querySelector('.length')?.classList.remove('valid');
		}
	}else{
		if (password_field.value.length >= 8) {
			passwordValidationWrapper.querySelector('.length')?.classList.add('valid');
		} else {
			passwordValidationWrapper.querySelector('.length')?.classList.remove('valid');
		}
	}


}

export {
	validate_password
}
